import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import ComplianceAlertBanner from '../../components/ui/ComplianceAlertBanner';
import SystemStatusIndicator from '../../components/ui/SystemStatusIndicator';
import UserContextSwitcher from '../../components/ui/UserContextSwitcher';
import QuickActionToolbar from '../../components/ui/QuickActionToolbar';
import FleetSummaryCards from './components/FleetSummaryCards';
import FleetMap from './components/FleetMap';
import PerformanceMetrics from './components/PerformanceMetrics';
import QuickActions from './components/QuickActions';
import RealTimeUpdates from './components/RealTimeUpdates';

const FleetDashboard = () => {
  useEffect(() => {
    // Simulate WebSocket connection for real-time updates
    console.log('Fleet Dashboard: Initializing real-time data connections...');
    
    // Cleanup function for WebSocket connections
    return () => {
      console.log('Fleet Dashboard: Cleaning up real-time connections...');
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Fleet Dashboard - Carbon Cost Router</title>
        <meta name="description" content="Comprehensive carbon compliance oversight and real-time emissions exposure across your entire fleet" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        <ComplianceAlertBanner />
        
        {/* Main Content */}
        <main className="pt-16">
          {/* Top Bar with System Status and User Context */}
          <div className="sticky top-16 z-50 bg-background/95 backdrop-blur border-b border-border">
            <div className="flex items-center justify-between px-6 py-3">
              <div className="flex items-center space-x-4">
                <h1 className="text-2xl font-bold text-foreground">Fleet Dashboard</h1>
                <SystemStatusIndicator />
              </div>
              <UserContextSwitcher />
            </div>
          </div>

          {/* Dashboard Content */}
          <div className="px-6 py-6 space-y-8">
            {/* Summary Cards */}
            <section>
              <FleetSummaryCards />
            </section>

            {/* Main Dashboard Grid */}
            <div className="grid grid-cols-1 xl:grid-cols-3 gap-8">
              {/* Left Column - Fleet Map */}
              <div className="xl:col-span-2">
                <FleetMap />
              </div>

              {/* Right Column - Real-time Updates */}
              <div className="xl:col-span-1">
                <RealTimeUpdates />
              </div>
            </div>

            {/* Performance Metrics */}
            <section>
              <PerformanceMetrics />
            </section>

            {/* Quick Actions */}
            <section>
              <QuickActions />
            </section>
          </div>
        </main>

        {/* Quick Action Toolbar */}
        <QuickActionToolbar />
      </div>
    </>
  );
};

export default FleetDashboard;